import { all } from 'redux-saga/effects'
import { combineReducers } from 'redux'
import UserSliceReducer from './../../components/modules/auth/redux/AuthSlice'
import * as auth from './../../components/modules/auth'
import SideBarSlice from 'src/Slices/SideBarSlice'
import listDetailFormSlice from 'src/Slices/listDetailFormSlice'
import activityReducer from 'src/Slices/activitySlice'
import statuForwardSlice from 'src/Slices/statuForwardSlice'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  activityReducer: activityReducer,
  statuForwardReducer:statuForwardSlice,
  userReducer: UserSliceReducer,
  sideBarState: SideBarSlice,
  listDetailForm: listDetailFormSlice
})



export function* rootSaga() {
  yield all([auth.saga()])
}
